// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TablePriceCell_price-cell__0G6\\+O {
  font-weight: 700;
  justify-content: center;
  gap: 0.2rem;
}

.TablePriceCell_price-cell__price__X0F6W {
  color: var(--primary-color);
  font-size: var(--text-lg);
  margin-inline-end: 0.5rem;
}

.TablePriceCell_price-cell__currency__gKZXj {
  color: var(--black-light);
  font-size: var(--text-sm);
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/TablePriceCell/TablePriceCell.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":[".price-cell {\n  font-weight: 700;\n  justify-content: center;\n  gap: 0.2rem;\n}\n\n.price-cell__price {\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  margin-inline-end: 0.5rem;\n}\n\n.price-cell__currency {\n  color: var(--black-light);\n  font-size: var(--text-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"price-cell": `TablePriceCell_price-cell__0G6+O`,
	"price-cell__price": `TablePriceCell_price-cell__price__X0F6W`,
	"price-cell__currency": `TablePriceCell_price-cell__currency__gKZXj`
};
export default ___CSS_LOADER_EXPORT___;
